import React, { useState } from 'react'
import { Box, Tab, Typography, Button, Grid, ListItemIcon, Menu, MenuItem } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Edit } from '@mui/icons-material';

function PolicySubTab(props) {
  const { policyTab } = props;
  const [value, setValue] = useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };
  const handleEditClick = () => {
    //TODO we can use for edit 
    //  const selectedItemData = faq.find(ele => ele.id === selectedIndex)
    //  handleEditFAQ(selectedItemData)
  }
  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <Grid>
      <Grid className='tableContainer' xs={12}>
        <Grid
          className='policyLayout'>
          <Box className='contentBoxStyle marginBlock10'>
            <TabContext value={value}>
              <Grid container
                className='tabBoxStyle'
                direction='row'
                justifyContent='space-between'
                alignItems='center'>
                <Grid item md={11}>
                  <TabList xs={6}
                    onChange={handleChange}>
                    <Tab label="Customer" value='1' className='tabStyle' />
                    <Tab label="Driver" value="2" className='tabStyle' />
                  </TabList>
                </Grid>
                <Grid item md={0.5} >
                  <Button onClick={(event) => handleClick(event)}
                  >
                    <div className="colorBlack">{
                      <MoreVertIcon />}
                    </div>
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    className=''
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  >
                    <MenuItem onClick={() => handleEditClick()} >
                      <ListItemIcon  >
                        <Edit fontSize="small" />
                      </ListItemIcon>
                      Edit
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
              <TabPanel value='1' className='tabPanelStyle'>
                {policyTab && policyTab.map((policy, index) => (
                  <div>  {policy.title && policy.body ?
                    <div key={index}>
                      <Typography className='marginTopBottom20' >{index + 1}. {policy.title}</Typography>
                      <div>
                        {policy.body.length > 1 ? policy.body.map((p, idx) => (
                          <div key={idx}>
                            <Typography>{index + 1}.{idx + 1} {p?.subTitle}</Typography>
                            <ul type='disc'>
                              <li>{p?.content[0]}</li>
                              <li>{p?.content[1]}</li>
                            </ul>
                          </div>
                        ))
                          : (<div key={index}>
                            <Typography>{index + 1}.{index}. {policy.body[0]?.subTitle}</Typography>
                            <ul type='disc'>
                              <li>{policy.body[0]?.content[0]}</li>
                              <li>{policy.body[0]?.content[1]}</li>
                            </ul>
                          </div>)}
                      </div>
                    </div>
                    : policy.body && policy.content ?
                      <div key={index}>
                        <Typography className='marginTopBottom20' > {policy.body}</Typography>
                        <div>
                          {policy.content.length > 1 && policy.content.map((p, idx) => (
                            <div className='marginTop' key={idx}>
                              <Typography>{idx + 1}. {p?.title}</Typography>
                              <Typography>{p?.description}</Typography>
                            </div>
                          ))}
                        </div>
                      </div>
                      :
                      <ol type={index} start={index + 1}>
                        <li key={index}><span> {policy.title} : </span>
                          <span>{policy.content}</span></li>
                      </ol>}
                  </div>
                ))}
              </TabPanel>
              <TabPanel value='2' className='tabPanelStyle'>
              {policyTab && policyTab.map((policy, index) => (
                  <div>  {policy.title && policy.body ?
                    <div key={index}>
                      <Typography className='marginTopBottom20' >{index + 1}. {policy.title}</Typography>
                      <div>
                        {policy.body.length > 1 ? policy.body.map((p, idx) => (
                          <div key={idx}>
                            <Typography>{index + 1}.{idx + 1} {p?.subTitle}</Typography>
                            <ul type='disc'>
                              <li>{p?.content[0]}</li>
                              <li>{p?.content[1]}</li>
                            </ul>
                          </div>
                        ))
                          : (<div key={index}>
                            <Typography>{index + 1}.{index}. {policy.body[0]?.subTitle}</Typography>
                            <ul type='disc'>
                              <li>{policy.body[0]?.content[0]}</li>
                              <li>{policy.body[0]?.content[1]}</li>
                            </ul>
                          </div>)}
                      </div>
                    </div>
                    : policy.body && policy.content ?
                      <div key={index}>
                        <Typography className='marginTopBottom20' > {policy.body}</Typography>
                        <div>
                          {policy.content.length > 1 && policy.content.map((p, idx) => (
                            <div className='marginTop' key={idx}>
                              <Typography>{idx + 1}. {p?.title}</Typography>
                              <Typography>{p?.description}</Typography>
                            </div>
                          ))}
                        </div>
                      </div>
                      :
                      <ol type={index} start={index + 1}>
                        <li key={index}><span> {policy.title} : </span>
                          <span>{policy.content}</span></li>
                      </ol>}
                  </div>
                ))}</TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PolicySubTab
